module.exports = __webpack_public_path__ + "static/media/asep.4c31acd6.jpg";